import ExpiredErrorIcon from '@/assets/svg/expired.svg?react';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import type { ErrorCodeMessageType } from '@/shared/constant/error/ErrorCodeMessageType';
import clsx from 'clsx';

export type ExpiredErrorProps = {
  value: ErrorCodeMessageType;
  className?: string;
};

export function ExpiredError(props: ExpiredErrorProps) {
  const { className } = props;

  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);

  return (
    <div
      className={clsx(
        'flex w-auto flex-col items-center justify-center max-os:p-5 os:w-[480px]',
        className,
      )}
    >
      <ExpiredErrorIcon />

      <div className="align-center mt-8 flex justify-center text-center text-2xl font-semibold text-color">
        {clientI18n('onlineShare.expired')}
      </div>

      <div className="align-center mt-2 text-center text-lg font-400 text-secondary">
        {clientI18n('onlineShare.expired.subTitle')}
      </div>
    </div>
  );
}
